export default __webpack_public_path__ + "static/media/person-icon.12ea4f36.png";